import { SET_AMBASSADOR_LIST, } from "./types";
import { apiCallV2 } from "../../utils/api";


export const GetAmbasadors = (page, count, filter, sort) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "GET",
        "admin/get-ambassadors",
        {},
        localStorage.getItem("access-token"),
        {
            page: page,
            count: count,
            filters: filter,
            sort: sort,
        },
    );

    if (res.status == 200) {
        dispatch({
            type: SET_AMBASSADOR_LIST,
            data: {
                list: res.data.ambassadors,
                count: res.data.count[0]["count(*)"]
            }
        })
    }

}

export const AddAmbassador = (selected) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "admin/add-user-to-ambassador",
        selected,
        localStorage.getItem("access-token"),
    );

    if (res.status == 200) {

        let { list, count } = getState().Ambassador;

        if (list.length > 9) {
            list.pop();
        }


        dispatch({
            type: SET_AMBASSADOR_LIST,
            data: {
                list: [
                    {
                        ambassadorID: res.data.data.id,
                        ...selected,
                    },
                    ...list,
                ],
                count: count + 1
            }
        })

        return { success: true };
    } else {
        return { success: false };
    }
}

export const RemoveAmbassador = (user) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "admin/remove-ambassador",
        {
            id: user.id
        },
        localStorage.getItem("access-token"),
    );

    if (res.status == 200 && res.data.data.update == "success") {
        let { list, count } = getState().Ambassador;
        let temp = [...list];

        temp = temp.filter(l => l.userID != user.id);

        dispatch({
            type: SET_AMBASSADOR_LIST,
            data: {
                list: temp,
                count: count
            }
        })

        return true;
    } else {
        return false;
    }
}

export const UpdateAmbassadorDetails = (details, id) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "admin/update-ambassador",
        {
            id: id,
            details: details,
        },
        localStorage.getItem("access-token"),
    );


    if (res.status == 200 && res.data.data.update == "success") {

        let { list, count } = getState().Ambassador;
        let temp = [...list];

        temp = temp.map((l, i) => {
            return id != l.userID
                ? l
                : {
                    ...l,
                    ...details
                }
        })
        dispatch({
            type: SET_AMBASSADOR_LIST,
            data: {
                list: temp,
                count: count
            }
        })
        
        return true;
    } else {
        return false;
    }
}
